module.exports = __webpack_public_path__ + "frontend/images/signpost/white@2.jpg?3f79fb5c27013d0a7dd77f962429597c";